<template>
  <div class="party-flow">
    <joinHead :title="title"></joinHead>
    <div class="cont" v-if="shows==0">
      <partyWork :name="name"></partyWork>
      <myWork :name="name"></myWork>
      <flowState :name="name"></flowState>
    </div>
    <!-- 留言板 -->
    <div class="leave" v-if="shows==1">
      <leaveMessage></leaveMessage>
    </div>

    <!-- 留言记录 -->
    <div class="board" v-if="shows==2">
      <leaveBoard></leaveBoard>
    </div>

    <!-- 活动房间 -->
    <div class="room" v-if="shows==3">
      <activeRoom :datas="junior"></activeRoom>
    </div>

    <!-- 模态框 -->
    <div class="motai" v-if="motai.motais">
      <div class="msg">
        <img src="@/assets/index/joinParty/dp-lc1-no2.png" alt />
        <div>
          <h5>{{motai.title}}</h5>
          <el-input v-if="motai.isput" placeholder="请输入房间号" v-model="motai.input" clearable></el-input>
          <p>{{motai.text}}</p>
          <button @click="motaiBut">{{motai.button}}</button>
        </div>
        <i class="el-icon-circle-close" @click="hide"></i>
      </div>
    </div>
  </div>
</template>
<script>
import joinHead from "./module/head";
import partyWork from "./module/partyWork";
import myWork from "./module/myWork";
import flowState from "./module/flowState";
// 留言板
import leaveMessage from "./module/leaveMessage";
import leaveBoard from "./module/leaveBoard";
// 活动房间
import activeRoom from "./module/activeRoom";

export default {
  data() {
    return {
      title: "",
      shows: 0, //0代表默认主页,1代表留言板,2代表留言记录,3代表活动房间,4代表视频列表
      motai: {
        motais: false,
        title: "",
        text: "",
        button: "",
        input: "",
        isput: false,
        activeId:""
      },
      name: "",
      junior: ""
    };
  },
  components: {
    joinHead,
    partyWork,
    myWork,
    flowState,
    leaveMessage,
    leaveBoard,
    activeRoom
  },
  methods: {
    motaiBut() {
      if (this.motai.button == "我知道了") this.motai.motais = false;
      else {
        if (this.motai.input != "") {
          this.axios
            .post("/api/Index/AddCheck", {
              userid: sessionStorage.getItem("id"),
              actiid: this.motai.activeId,
              id:this.motai.input,
              isjoin: 1,
            })
            .then(e => {            
                
              switch (e.data.code) {

                case 0:
                  this.motai.text = "签到成功";
                  this.motai.button = "我知道了";
                  break;
                default:
                  alert(e.data.msg)
                  this.motai.button = "我知道了";

                  break;
              }
            });
        }
      }
    },
    hide(){      
      // console.log('asd');
      
      this.motai.motais=false
    }
  },
  created() {
    this.title = this.$route.query.title;
    if (!this.$route.query.name) this.name = 0;
    else this.name = Number(this.$route.query.name);
  },
  mounted() {}
};
</script>
<style lang='scss' scoped>
.party-flow {
  .motai {
    .msg {
      i{
        color: #fff;
        font-size: .6rem;
        margin-top: 1rem;
      }
      div {
        .el-input {
          width: 80%;
        }
        button {
          background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
          font-size: 0.28rem;
          color: #fff;
          border: none;
          padding: 0.1rem 0.4rem;
          border-radius: 0.34rem;
        }
        h5 {
          font-weight: bold;
          font-size: 0.3rem;
        }
        p {
          padding: 0.2rem;
          font-size: 0.28rem;
          color: #999999;
        }
        width: 4.4rem;
        margin: 0 auto;
        margin-top: -4rem;
        line-height: 1;
      }
      img {
        width: 4.4rem;
      }
      text-align: center;
      margin-top: 20vh;
      position: relative;
    }
    position: fixed;
    width: 100%;
    top: 0;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.2);
  }
  .room,
  .board,
  .leave,
  .cont {
    background: #fff2df;
    position: absolute;
    width: 100%;
    top: 4.34rem;
    z-index: -10;
    padding-bottom: 0.2rem;
  }
  position: relative;
}
</style>

